'use client';

import { c as _c } from "react/compiler-runtime";
import type { ChainId, MarketId } from '@morpho-org/blue-sdk';
import { useEffect } from 'react';
import { useAutoDeleverage } from '@/components/common/AutoDeleverage/hooks/useAutoDeleverage';
interface AdlAuthDetectorProps {
  marketId: MarketId;
  chainId: ChainId;
  onAuthorized: () => void;
}

/**
 * Renders nothing; reads Auto-Deleverage authorization for a single market and
 * calls `onAuthorized` once the position is authorized. Used both per-position
 * by the dashboard watcher and standalone by the market-page watcher.
 */
const AdlAuthDetector = t0 => {
  const $ = _c(4);
  const {
    marketId,
    chainId,
    onAuthorized
  } = t0;
  const {
    status
  } = useAutoDeleverage(marketId, chainId);
  let t1;
  let t2;
  if ($[0] !== onAuthorized || $[1] !== status) {
    t1 = () => {
      if (status === "authorized") {
        onAuthorized();
      }
    };
    t2 = [status, onAuthorized];
    $[0] = onAuthorized;
    $[1] = status;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  return null;
};
export default AdlAuthDetector;